// test1442
(1442 && 0);
